var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstallerStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.230469 0.988403C0.230469 0.712261 0.454326 0.488403 0.730469 0.488403H17.162C17.4381 0.488403 17.662 0.712261 17.662 0.988403V2.31413H18.9877C19.2639 2.31413 19.4877 2.53799 19.4877 2.81413V8.29131C19.4877 8.56745 19.2639 8.79131 18.9877 8.79131H17.662V10.117C17.662 10.3932 17.4381 10.617 17.162 10.617H0.730469C0.454326 10.617 0.230469 10.3932 0.230469 10.117V0.988403ZM16.662 2.81413L16.662 2.81071V1.4884H1.23047V9.61703H16.662V8.29473L16.662 8.29131L16.662 8.28789V2.81755L16.662 2.81413ZM17.662 3.31413V7.79131H18.4877V3.31413H17.662ZM9.81869 3.09148C9.97186 2.86171 9.90978 2.55128 9.68001 2.3981C9.45025 2.24493 9.13981 2.30701 8.98664 2.53678L7.16091 5.27537C7.05862 5.4288 7.04909 5.62607 7.1361 5.78865C7.22311 5.95123 7.39254 6.05272 7.57693 6.05272H9.38127L8.07377 8.01396C7.9206 8.24372 7.98268 8.55416 8.21245 8.70733C8.44221 8.86051 8.75265 8.79842 8.90582 8.56866L10.7316 5.83007C10.8338 5.67664 10.8434 5.47937 10.7564 5.31679C10.6694 5.15421 10.4999 5.05272 10.3155 5.05272H8.51119L9.81869 3.09148Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallerStorage);
export default __webpack_public_path__ + "static/media/icon_installer_storage.550e39f04cbb44b9d987f689ac0ef477.svg";
export { ForwardRef as ReactComponent };